// extracted by mini-css-extract-plugin
module.exports = {"image":"_2n863Ch04Xm6I8qOb9IjvQ"};